import React from 'react';
import { TDropdownToggle } from './dropdown.model';
import DropdownContainer from './dropdown-container';

const DropdownToggle = (props: TDropdownToggle) => {
  const { className, children } = props;
  return <div className={`${className || ''}`}>{children}</div>;
};

export default DropdownToggle;

DropdownContainer.displayName = 'Dropdown.Toggle';
